<template>
</template>
<script>
export default {
  mounted () {
    this.$store.dispatch('account/logout').then((response) => {
      return location.reload()
      // return this.$router.push('login')
    }).catch(() => {
      return location.reload()
      // return this.$router.push('login')
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Auth/Logout.vue